export default "__VITE_ASSET__MBIQTjMh__"